<template>
  <div
    class="asc-fault-monitor-wrapper"
    data-automation-id="wrapper_fault_monitor"
  >
    <asc-accordion :value="1">
      <asc-accordion-item>
        <template slot="header">
          <asc-section-header title="Fault Monitors"></asc-section-header>
        </template>
        <asc-fault-monitor-list
          :values="values"
          :loading="loading"
        ></asc-fault-monitor-list>
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'
import AscSectionHeader from '@/components/atoms/AscSectionHeader'
import AscFaultMonitorList from '@/components/molecules/AscFaultMonitorList'

export default {
  name: 'AscFaultMonitorWrapper',

  components: {
    AscAccordion,
    AscAccordionItem,
    AscSectionHeader,
    AscFaultMonitorList,
  },

  props: {
    values: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getCount() {
      return this.values ? this.values.length.toString() : '0'
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-fault-monitor-wrapper {
  background-color: $primary-white;
  margin-bottom: 16px !important;
}
</style>
